import { JSONSchema7 } from 'json-schema';
import { ErrorsByPointer, formatFieldPath, stripEmptyValues } from './errorMapping';
import { validateAgainstSchema } from './jsonSchemaValidator';

export type FormDataValidation = {
    isValid: boolean;
    messages: string[];
    errorsByPointer: ErrorsByPointer;
};

export const validateFormData = (schema: JSONSchema7, data: unknown, title?: string): FormDataValidation => {
    const label = title || schema.title || 'Form';
    try {
        const { isValid, errors, errorsByPointer } = validateAgainstSchema(stripEmptyValues(data ?? {}), schema);
        const messages = errors.map(e => `${label}${formatFieldPath(e.property)}: ${e.message}`);
        return { isValid, messages, errorsByPointer };
    } catch (err: any) {
        return {
            isValid: false,
            messages: [`${label}: ${err?.message || 'Validation error - please check your inputs.'}`],
            errorsByPointer: { '': ['Validation failed. Please review your inputs.'] },
        };
    }
};
